import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { QuickComposeViewState } from 'owa-calendar-compose-types';
import { QUICK_COMPOSE_FORM_TYPE } from 'owa-calendar-helpers-types/lib/ComposeTypes';

export default function getQuickComposeViewState(): QuickComposeViewState {
    const store = getComposeStore();

    if (store.openedForm == QUICK_COMPOSE_FORM_TYPE) {
        return store.uiState as QuickComposeViewState;
    }

    return null;
}
